import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { SelectProjectName } from './SelectProjectNameExtension';

export const SelectProjectNameFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'SelectProjectName',
    component: SelectProjectName,
  }),
);
